"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPSelectAccountComponent = void 0;
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../shared/services/expresspay.services");
const helper_service_1 = require("../../mma/shared/services/helper.service");
const _ = require("underscore");
const router_1 = require("@angular/router");
const shared_1 = require("../../mma/shared");
const ng_recaptcha_1 = require("ng-recaptcha");
class CSEPSelectAccountComponent {
    constructor(expressPayService, accountService, helperService, router) {
        this.expressPayService = expressPayService;
        this.accountService = accountService;
        this.helperService = helperService;
        this.router = router;
        this.animationState = 'out';
        this.isAccType = 'hide';
        this.expandedWls = false;
        this.expandedHS = false;
        this.loaderPin = false;
        this.classes = 'col-12';
        this.scrollTop();
    }
    ngOnInit() {
        this.preExpandLob();
        this.checkMMALoginStatus();
        this.isAuthenticated();
        this.getCaptchaSiteKey();
        ng_recaptcha_1.RecaptchaComponent.prototype.ngOnDestroy = function () { };
    }
    preExpandLob() {
        const params = new URLSearchParams(window.location.search);
        const lob = params === null || params === void 0 ? void 0 : params.get('lob');
        const authMethod = params === null || params === void 0 ? void 0 : params.get('authType');
        if (lob === 'homeservices') {
            this.expandedHS = true;
            this.expandedWls = false;
        }
        else if (lob === 'wireless') {
            this.expandedHS = false;
            this.expandedWls = true;
            this.animationState = 'in';
        }
        if (authMethod === 'account') {
            this.loginType = 'ACCOUNT-LOGIN';
        }
        else if (authMethod === 'mobile') {
            this.loginType = 'MDN-LOGIN';
        }
    }
    expressPayLoginCheck() {
        this.loader = true;
        this.expressPayService.getProfileState().subscribe((details) => {
            if (details.securityStatus === 4) {
                this.expressPayService.getSessioId().pipe(operators_1.finalize(() => this.expressPayService.logOut(this.sessionId).subscribe((data) => {
                    this.loader = false;
                    window.location.reload();
                    this.expressPayLogin();
                }, (err) => {
                    this.error = err[err.length - 1];
                })))
                    .subscribe((res) => {
                    this.sessionId = res;
                }, (err) => {
                    this.error = err[err.length - 1];
                });
            }
            else {
                this.loader = false;
                this.expressPayLogin();
            }
        }, (err) => {
            this.loader = false;
        });
        this.isCaptchaValidated = false;
    }
    expressPayLogin() {
        if (this.loginType === 'MDN-LOGIN') {
            this.zipCode = this.wlsMobZIPCode;
        }
        else if (this.loginType === 'ACCOUNT-LOGIN') {
            this.zipCode = this.wlsAccZIPCode;
            this.wlsPrepaidPin = null;
        }
        if (this.loginType === 'MDN-LOGIN') {
            this.mobToAPI = this.wlsMobNum;
            this.wlsPrepaidPin = null;
            this.wlsAccNum = null;
        }
        else if (this.loginType === 'PREPAID-LOGIN') {
            this.mobToAPI = this.wlsPrepaidMobNum;
            this.zipCode = null;
            this.wlsAccNum = null;
        }
        const content = {
            'mobileNumber': this.mobToAPI,
            'zipCode': this.zipCode,
            'loginType': this.loginType,
            'accountNumber': this.wlsAccNum
        };
        this.loader = true;
        this.error = null;
        this.scrollTop();
        this.expressPayService.expressPayLogin(content).subscribe((data) => {
            if (!_.isEmpty(data) && data.hasOwnProperty('url')) {
                this.router.navigate(['/prepaid/billing']);
            }
            else {
                this.router.navigate(['/wireless/billing']);
            }
            this.error = null;
        }, (err) => {
            this.loader = false;
            this.error = err[err.length - 1];
            this.scrollTop();
        });
        // Report glassbox items
        try {
            const windowDetector = '_detector';
            const detector = window[windowDetector];
            if (this.mobToAPI) {
                detector.triggerCustomEvent('expresspay-mdn', this.mobToAPI.replace('-', ''));
            }
            if (this.wlsAccNum) {
                detector.triggerCustomEvent('expresspay-account', this.wlsAccNum);
            }
        }
        catch (ex) {
            // either detector.js failed to load or something happened above.. continue and don't break anything
        }
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    formatMobile(event) {
        if (!_.isEmpty(event.currentTarget.value)) {
            event.currentTarget.value = event.currentTarget.value.replace(/[^\d]/g, '');
            if (event.currentTarget.value.length > 10) {
                event.currentTarget.value = event.currentTarget.value.substring(0, 10);
            }
            event.currentTarget.value = event.currentTarget.value.replace(/^(\d{3})(\d{3})(\d{4})+$/, '$1-$2-$3');
        }
        if (event.currentTarget.value.length === 12) {
            this.checkPinOrSSN();
        }
    }
    onPasteHs(event) {
        if (!_.isEmpty(event.clipboardData.getData('text'))) {
            this.hsPhoneNumber = this.getFormattedMdn(event.clipboardData.getData('text'));
        }
    }
    onPaste(event) {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const formattedText = pastedText.replace(/[^\d]/g, '');
        this.wlsAccNum = formattedText;
    }
    getFormattedMdn(mobNum) {
        mobNum = mobNum.replace(/\+1|\(|\)|-|[a-zA-Z]| /g, '');
        if (mobNum.length > 10) {
            mobNum = mobNum.substring(0, 10);
        }
        return mobNum.replace(/^(\d{3})(\d{3})(\d{4})+$/, '$1-$2-$3');
    }
    validateFiberAcc() {
        var _a;
        let formData;
        if (this.loginType === 'MDN-LOGIN') {
            formData = {
                'fiberPhoneNumber': (_a = this.hsPhoneNumber) === null || _a === void 0 ? void 0 : _a.replaceAll('-', ''),
                'fiberZipCode': this.hsZipCode
            };
        }
        else {
            formData = {
                'fiberAccountNumber': this.hsAccountId,
                'fiberZipCode': this.hsZipCode
            };
        }
        this.loader = true;
        this.error = null;
        this.scrollTop();
        this.expressPayService.handleFiberLogin(formData).subscribe((data) => {
            this.router.navigate(['/fiber/billing']);
        }, (err) => {
            this.showError = true;
            this.loader = false;
            this.error = err[err.length - 1];
        });
        this.isCaptchaValidated = false;
        // Report glassbox items
        try {
            const windowDetector = '_detector';
            const detector = window[windowDetector];
            if (this.mobToAPI) {
                detector.triggerCustomEvent('expresspay-mdn', this.hsPhoneNumber.replace('-', ''));
            }
            if (this.wlsAccNum) {
                detector.triggerCustomEvent('expresspay-account', this.hsAccountId);
            }
        }
        catch (ex) {
            // either detector.js failed to load or something happened above.. continue and don't break anything
        }
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    checkMMALoginStatus() {
        this.loader = true;
        this.accountService.getLoggedInStatus().toPromise().then((response) => {
            this.loader = false;
            this.isSignedIntoMMA = response === null || response === void 0 ? void 0 : response.isLoggedIn;
        });
    }
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            this.loader = false;
            if (!_.isEmpty(data) && data.hasOwnProperty('isMMAAuthenticated')) {
                this.router.navigate(['/wireless/billing']);
            }
            else if (!_.isEmpty(data) && data.hasOwnProperty('isPrepaidAuthenticated') && data.hasOwnProperty('url')) {
                this.router.navigate(['/prepaid/billing']);
            }
            else if (!_.isEmpty(data) && data.hasOwnProperty('isFiberAuthenticated')) {
                this.router.navigate(['/fiber/billing']);
            }
        }, (err) => {
            this.loader = false;
        });
        this.isTitleShown = true;
        this.isNoSSN = false;
        this.isAccType = 'notPrepaid';
        this.isCaptchaValidated = false;
    }
    slideDown() {
        this.animationState = 'in';
        this.isCaptchaValidated = false;
    }
    slideUp() {
        this.animationState = 'out';
        setTimeout(() => {
            this.expandedHS = true;
            this.expandedWls = false;
            this.isTitleShown = false;
            this.loginType = null;
            this.isCaptchaValidated = false;
            this.hsSec.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }, 1100);
    }
    checkPinOrSSN() {
        let valueMob;
        let valueAcc;
        if (this.loginType === 'MDN-LOGIN') {
            valueMob = this.wlsMobNum;
            valueAcc = null;
        }
        else if (this.loginType === 'ACCOUNT-LOGIN') {
            valueAcc = this.wlsAccNum;
            valueMob = null;
        }
    }
    lookUp(event) {
        if (event.currentTarget.value.length === 10) {
            this.isNoSSN = false;
            this.isAccType = 'notPrepaid';
        }
    }
    lookUpPrepaid(data) {
        if (data) {
            if (data.noSSN) {
                this.isNoSSN = true;
            }
            else {
                this.isNoSSN = false;
            }
            if (!data.accountType || data.accountType === 'CSpireAccountUnavailableES') {
                this.isAccType = this.loginType === 'MDN-LOGIN' ? 'nonCSpireMdn' : 'nonCSpireAccount';
            }
            else if (data.accountType === 'AP') {
                this.isAccType = 'prepaid';
            }
            else if (data.accountType === 'PP') {
                this.isAccType = 'postpaid';
            }
            else if (data.accountType === 'BUSINESS') {
                this.isAccType = 'business';
            }
            else {
                this.isAccType = 'notPrepaid';
            }
        }
    }
    expandingWireless() {
        this.expandedWls = true;
        this.expandedHS = false;
        this.isTitleShown = false;
        this.loginType = null;
    }
    resetLoginInfo() {
        this.isAccType = 'hide';
        this.wlsAccNum = null;
        this.wlsMobNum = null;
        this.wlsMobZIPCode = null;
        this.wlsAccZIPCode = null;
        this.error = null;
    }
    resolved(captchaResponse) {
        const content = {
            'recaptchaResponse': captchaResponse,
        };
        this.expressPayService.validateReCaptcha(content).subscribe((data) => {
            this.loader = false;
            this.isCaptchaValidated = true;
        }, (err) => {
            this.loader = false;
        });
    }
    getCaptchaSiteKey() {
        this.loader = true;
        this.expressPayService.captchaSiteKey().subscribe((data) => {
            this.captchaKey = data.siteKey;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    onLoginTypeChange(event) {
        this.isCaptchaValidated = false;
    }
    redirectToMMA() {
        window.location.href = '/my_account/personal/';
    }
}
exports.CSEPSelectAccountComponent = CSEPSelectAccountComponent;
//# sourceMappingURL=selectaccount.component.js.map